import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { WebsiteBuilderCanvas } from '@futuredev/website-builder';
import { useTheme } from '../../contexts/ThemeContext';

export default function WebsiteBuilder(): React.ReactElement {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { isDark } = useTheme();

  return (
    <WebsiteBuilderCanvas
      pageId={id}
      onPageIdChange={(newId) => navigate(`/admin/website-builder/${newId}`, { replace: true })}
      isDark={isDark}
      showBackLink
      backLinkTo="/admin/website-pages"
      backLinkLabel="Pages"
    />
  );
}
